import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { customGetAPI } from "services/utils/CustomAPI";
import { useForm } from "react-hook-form";
import { Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { themes } from "services/constants";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.css";
import "../../../assets/scss/datepicker.css";
import { leaveManagamentPlaceholder } from "services/constants/PlaceHolder";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { showToast } from "services/utils/Status";
import { customAPI } from "services/utils/CustomAPI";
import { minimum3Characters } from "services/constants/ErrorMessages";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  formHeader,
  formBackGroundColor,
  formKeyText,
} from "services/constants/Styles";

export const CancelLeave = ({
  setCancelConfirmation,
  cancelLeaveData,
  setCancelLeaveData,
  leaveYearId,
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { domain } = useSelector((state) => state.tokenReducer);
  const [triggerApi, setTriggerApi] = useState(true);
  const [applyLeaveDates, setApplyLeaveDates] = useState([]);
  const [getLeaveDates, setGetLeaveDates] = useState({});
  const [selectedDates, setSelectedDates] = useState([]);
  const height = window.innerHeight < 700 ? true : false;
  const [buttonLoader, setButtonLoader] = useState(false);

  const [state, setState] = useState(() => {
    return {
      start: moment(cancelLeaveData?.from_date, "DD-MM-YYYY"),
      end: moment(cancelLeaveData?.to_date, "DD-MM-YYYY"),
    };
  });

  useEffect(() => {
    if (applyLeaveDates && Object.keys(applyLeaveDates).length > 0) {
      const allDates = Object.keys(applyLeaveDates);
      setSelectedDates(allDates);
    }
  }, [applyLeaveDates]);

  const { start, end } = state;

  const handleCallback = (start, end) => {
    setState({ start, end });

    const dates = [];
    const currentDate = moment(start);

    while (currentDate.isSameOrBefore(end, "day")) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate.add(1, "day");
    }

    setSelectedDates(dates);
  };

  const label = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");

  useEffect(() => {
    const fetchLeaveDetails = async () => {
      const res = await customGetAPI(
        `${domain}valid_business_days/?leave_request_id=${cancelLeaveData?.id}`
      );
      if (res.ok) {
        const dateValidation = res?.responseDetails?.date_validation || {};
        const validDates = Object.entries(dateValidation)
          .filter(([_, status]) => status === "valid")
          .map(([date]) => date);
        setGetLeaveDates(validDates);
        setApplyLeaveDates(res?.responseDetails?.date_validation);
      }
    };
    if (triggerApi) {
      fetchLeaveDetails();
      setTriggerApi(false);
    }
  }, [cancelLeaveData?.id, cancelLeaveData.leave_type_id, domain, triggerApi]);

  const onSubmit = async (data) => {
    setButtonLoader(true);
    const payload = {
      leave_request_id: cancelLeaveData?.id,
      date_validation: applyLeaveDates,
      invalid_dates: selectedDates,
      leave_year_id: leaveYearId,
      reason: data.reason,
    };
    const response = await customAPI(
      `${domain}cancel_create_leave_request/`,
      "PUT",
      payload
    );
    if (response.ok) {
      showToast("success", response?.responseDetails?.message);
      setCancelConfirmation(false);
      setCancelLeaveData({});
      setButtonLoader(false);
    } else {
      setButtonLoader(false);
    }
  };

  const validCancelledCount = selectedDates.filter(
    (date) => applyLeaveDates[date] === "valid"
  ).length;

  return (
    <React.Fragment>
      <Mui.Grid container>
        <BackArrow
          actionFunction={() => {
            setCancelConfirmation(false);
            setCancelLeaveData({});
          }}
        />
        <Mui.Typography
          sx={{ fontWeight: "bold", fontSize: 27, paddingTop: 1 }}
        >
          Leave Summary / Cancel Leave
        </Mui.Typography>
      </Mui.Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid
          container
          sx={{
            paddingTop: "7%",
            paddingLeft: "16%",
            paddingRight: "16%",
            paddingBottom: "5%",
          }}
        >
          <Mui.Grid
            container
            xs={12}
            sx={{
              border: `2px solid ${themes.sidebarDivider}`,
              borderRadius: "10px 10px 10px 10px",
            }}
          >
            <Mui.Grid
              xs={12}
              sx={{
                backgroundColor: formBackGroundColor,
                padding: {
                  xs: 0.5,
                  sm: 0.5,
                  md: 0.5,
                  lg: 0.5,
                  xl: 1,
                },
                textAlign: "center",
                borderBottom: `2px solid ${themes.sidebarDivider}`,
              }}
            >
              <Mui.Typography sx={formHeader}>Cancel Leave</Mui.Typography>
            </Mui.Grid>
            <Mui.Grid container sx={{ padding: 2 }}>
              <Mui.Grid
                container
                sx={{
                  ml: 1,
                  mr: 1,
                  border: `2px solid ${themes.sidebarDivider}`,
                  borderRadius: 3,
                }}
              >
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={1}></Mui.Grid>
                  <Mui.Grid xs={4.5}>
                    <Mui.Typography sx={formKeyText}>
                      Leave Dates &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Shows the original dates for which leave was applied."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}></Mui.Grid>
                  <Mui.Grid container xs={5.5} sx={{ mt: 2 }}>
                    <Mui.Grid item xs={height ? 3 : 2.5}>
                      <Mui.Typography sx={{ fontWeight: 600 }}>
                        {cancelLeaveData?.from_date}
                      </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item xs={1.2}>
                      <Mui.Typography
                        sx={{ fontWeight: 600, textAlign: "left" }}
                      >
                        To
                      </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item xs={4}>
                      <Mui.Typography sx={{ fontWeight: 600 }}>
                        {cancelLeaveData?.to_date}
                      </Mui.Typography>
                    </Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={1}></Mui.Grid>
                  <Mui.Grid xs={4.5}>
                    <Mui.Typography sx={formKeyText}>
                      Business days &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Displays working days within the selected leave period, excluding weekends and holidays."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}></Mui.Grid>
                  <Mui.Grid xs={4} sx={{ mt: 2 }}>
                    <Mui.Typography sx={{ fontWeight: 600 }}>
                      {cancelLeaveData?.business_days}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid
                container
                sx={{
                  ml: 1,
                  mr: 1,
                  mt: 2,
                  border: `2px solid ${themes.sidebarDivider}`,
                  borderRadius: 2,
                }}
              >
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={1}></Mui.Grid>
                  <Mui.Grid xs={4.5}>
                    <Mui.Typography sx={formKeyText}>
                      Dates to be cancelled &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title=" Select the specific dates you want to cancel from the originally approved leave."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}></Mui.Grid>
                  <Mui.Grid item xs={5.5} sx={{ paddingTop: 1 }}>
                    {Array.isArray(getLeaveDates) &&
                      getLeaveDates.length > 0 && (
                        <DateRangePicker
                          initialSettings={{
                            startDate: start.toDate(),
                            endDate: end.toDate(),

                            applyClass: "custom-apply-btn",
                            cancelClass: "custom-cancel-btn",
                            minDate: moment(
                              cancelLeaveData?.from_date,
                              "DD-MM-YYYY"
                            ),
                            maxDate: moment(
                              cancelLeaveData?.to_date,
                              "DD-MM-YYYY"
                            ),
                            locale: {
                              format: "DD/MM/YYYY",
                            },

                            isInvalidDate: (date) => {
                              const formatted = date.format("YYYY-MM-DD");
                              return !getLeaveDates.includes(formatted);
                            },
                          }}
                          onCallback={handleCallback}
                        >
                          <TextField
                            id="reportrange"
                            // label="Select Range"
                            variant="outlined"
                            label=""
                            placeholder={leaveManagamentPlaceholder.dateFormat}
                            value={label}
                            size="small"
                            InputProps={{
                              readOnly: true,
                              notched: false,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton>
                                    <DateRangeIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            InputLabelProps={{ shrink: true, required: true }}
                            fullWidth
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                legend: {
                                  display: "none",
                                },
                              },
                            }}
                          />
                        </DateRangePicker>
                      )}
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={1}></Mui.Grid>
                  <Mui.Grid xs={4.5}>
                    <Mui.Typography sx={formKeyText}>
                      No of days to be cancelled &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Indicates the total number of business days selected for cancellation."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}></Mui.Grid>
                  <Mui.Grid xs={4} sx={{ mt: 2 }}>
                    <Mui.Typography sx={{ fontWeight: 600 }}>
                      {cancelLeaveData?.is_half_day ? 0.5 : validCancelledCount}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={1}></Mui.Grid>
                  <Mui.Grid xs={4.5}>
                    <Mui.Typography sx={formKeyText}>
                      Net Leave &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Shows the revised number of leave days remaining after cancellation."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}></Mui.Grid>
                  <Mui.Grid xs={4} sx={{ mt: 2 }}>
                    <Mui.Typography sx={{ fontWeight: 600 }}>
                      {cancelLeaveData?.is_half_day
                        ? cancelLeaveData?.business_days - 0.5
                        : cancelLeaveData?.business_days - validCancelledCount}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ padding: 1 }}>
                  <Mui.Grid xs={1}></Mui.Grid>
                  <Mui.Grid xs={4.5}>
                    <Mui.Typography sx={formKeyText}>
                      Reason &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Provide a brief explanation for why you’re cancelling this leave request"
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}></Mui.Grid>
                  <Mui.Grid xs={5.6}>
                    <Mui.TextField
                      sx={{
                        marginTop: 1,
                        width: "100%",
                      }}
                      id="reason"
                      placeholder="Enter a reason for your cancel leave"
                      {...register("reason", {
                        required: "Reason for cancel leave is required",
                        validate: {
                          minLengthNoSpaces: (value) => {
                            if (value?.trim().length < 3 && value !== "") {
                              return minimum3Characters;
                            } else {
                              return true;
                            }
                          },
                        },
                      })}
                      multiline
                      rows={2}
                      error={errors.reason}
                      helperText={errors.reason && errors.reason.message}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid
                container
                xs={11.5}
                sx={{
                  paddingTop: 1,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Mui.Grid item>
                  <CustomButton
                    actionName="Update"
                    typeName="submit"
                    disableAction={buttonLoader}
                  />
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
